import { IReviewResponseDto } from '../../shared/models/responses/review.response'
import { Education } from './education';
import { Experience } from './experience';
import { ProfileSkill } from './profile-skill';
import { Profile } from './profile';
import { Certificate } from './certificate';
import { PortfolioAttachment } from './portfolio-attachment';

export class Resume {
    public id: string;
    public accountId: string;
    public aboutMe: string;
    public profile: Profile;
    public educations: Education[] = [];
    public experiences: Experience[] = [];
    public skills: ProfileSkill[] = [];
    public certificates: Certificate[] = [];
    public portfolioAttachments: PortfolioAttachment[] = [];
    public reviews: IReviewResponseDto[] = [];

    public static parse(jsonData): Resume {
        let resume = new Resume();
        resume = Object.assign(resume, jsonData) as Resume;

        if(resume.profile) {
            resume.profile = Profile.parse(resume.profile);
        }

        if(resume.educations) {
            resume.educations = resume.educations.map(edu => Education.parse(edu));
        }

        if(resume.experiences) {
            resume.experiences = resume.experiences.map(exp => Experience.parse(exp));
        }

        if(resume.skills) {
            resume.skills = resume.skills.map(skill => ProfileSkill.parse(skill));
        }

        return resume;
    }
}
